import { render, staticRenderFns } from "./shebao.vue?vue&type=template&id=63154a54&"
import script from "./shebao.vue?vue&type=script&lang=js&"
export * from "./shebao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports